import { render } from "./MiTabs.vue?vue&type=template&id=15949c40&scoped=true"
import script from "./MiTabs.vue?vue&type=script&lang=js"
export * from "./MiTabs.vue?vue&type=script&lang=js"

import "./MiTabs.vue?vue&type=style&index=0&id=15949c40&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15949c40"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs});
